import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#FBE9B1"
      d="M11.288 16.3a8.49 8.49 0 0 1 5.687-5.912h.013c.012-.125.012-.25.012-.375A7.996 7.996 0 0 0 10.8 2.2 8.01 8.01 0 0 1 3 12a8.5 8.5 0 0 1-1.8-.2 8.01 8.01 0 0 0 4.675 5.563A5.46 5.46 0 0 1 9.5 16a5.3 5.3 0 0 1 1.788.3"
    />
    <path
      fill="#E2BA2B"
      d="M9.823 2.415a1 1 0 0 1 1.202-1.19A9 9 0 0 1 18 10l-.002.218a3 3 0 0 1-.008.168l-.102 1.08-1.991-.191.096-.996a7.002 7.002 0 0 0-3.764-6.495l-.238-.118.009.335a9 9 0 0 1-2.424 6.136l-.216.223A9.01 9.01 0 0 1 2.996 13l-.326-.009.063.132q.295.59.697 1.117l.207.258a7 7 0 0 0 2.629 1.944l.92.39-.781 1.842-.92-.391a9.01 9.01 0 0 1-5.259-6.257 1 1 0 0 1 1.19-1.203A7.01 7.01 0 0 0 10 4.005a7.6 7.6 0 0 0-.178-1.59"
    />
    <path
      fill="#CEEDFF"
      d="M11 18.5a8.5 8.5 0 1 1 8.5 8.5h-10a5.499 5.499 0 0 1-3.889-9.39 5.5 5.5 0 0 1 5.677-1.31"
    />
    <path
      fill="#80C4FF"
      d="M15.864 9.723A9.5 9.5 0 1 1 19.5 28h-10a6.499 6.499 0 0 1-4.596-11.096 6.5 6.5 0 0 1 5.515-1.84l.21.034.007-.015q.314-.815.776-1.565l.19-.296a9.5 9.5 0 0 1 4.262-3.499m5.099 1.421A7.5 7.5 0 0 0 12 18.5a1 1 0 1 1-2 0q0-.706.103-1.398l.01-.062-.019-.002a4 4 0 0 0-.296-.03L9.5 17a4.499 4.499 0 1 0 0 9h10a7.5 7.5 0 0 0 6.929-4.63 7.5 7.5 0 0 0-1.626-8.174 7.5 7.5 0 0 0-3.84-2.052"
    />
  </svg>
);
const SvgIconWeatherCloudMoon = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherCloudMoon);
export default Memo;
